import { useElementSize } from '@vueuse/core/index';

import { BREAKPOINTS } from '@/utils/constants/common';

export default function useSize(target: string | Ref<HTMLElement | null>) {
  const el = typeof target === 'string' ? useTemplateRef(target) : target;
  const { width, height } = useElementSize(el);

  const isDesktopSize = computed<boolean>(() => {
    return width.value >= BREAKPOINTS.DESKTOP;
  });
  const isTabletSize = computed<boolean>(() => {
    return width.value < BREAKPOINTS.DESKTOP && width.value >= BREAKPOINTS.TABLET;
  });
  const isMobileSize = computed<boolean>(() => {
    return width.value < BREAKPOINTS.TABLET;
  });

  return {
    width,
    height,
    isDesktopSize,
    isTabletSize,
    isMobileSize,
  };
}
